import React, { useEffect, useState } from "react";
import { TextField, Typography } from "@mui/material";
import { Container, Spinner } from "react-bootstrap";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
import {
  getLoggedUserAction,
  updateUserProfileDataAction,
} from "../../../../redux/actions/AuthAction";
import { useDispatch, useSelector } from "react-redux";
const Profile = ({ userData }) => {
  const [Passwordp, setPasswordp] = useState("password");
  const [Passwordc, setPasswordc] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordconfirmInput, setpasswordconfirmInput] = useState("");
  const [Name, setName] = useState("");
  const [Phone, setPhone] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const resCurrnt = useSelector((state) => state.authReducer.currentUser);

  const [Email, setEmail] = useState("");
  const dispatch = useDispatch();
  const [Code, setCode] = useState("");
  useEffect(() => {
    setName(userData.Name);
    setPhone(userData.PhoneNumber);
    setCode(userData.Id);
    setEmail(userData.Email);
  }, [userData]);
  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };
  const tryChangeCode = () => {
    notify("غير مسموح بتغير كود المستخدم", "warn");
  };
  const tryChangePhone = () => {
    notify("غير مسموح بتغير رقم الهاتف", "warn");
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Name === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (Phone.length <= 10) {
      notify("يجب ادخال رقم هاتف صحيح", "error");
      return;
    }
    if (passwordconfirmInput !== passwordInput) {
      notify("يجب ان تكون كلمة السر متطابقة", "error");
      return;
    }
    if (passwordInput && passwordconfirmInput === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      updateUserProfileDataAction({
        Id: Code,
        Name: Name,
        Email: Email,
        NewPassword: passwordInput !== "" ? passwordInput : null,
      })
    );

    setPasswordInput("");
    setpasswordconfirmInput("");
    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.authReducer.userProfile);
  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.data) {
          if (
            res.data.ResponseMessage === "This phone number is already exist"
          ) {
            notify("هذا الرقم مسجل من قبل", "error");
          } else if (
            res.data.ResponseMessage === "Great, profile updated succesfully"
          ) {
            notify("تم التعديل بنجاح", "success");
            dispatch(getLoggedUserAction());
          }
        }
      } else notify("لايمكن التعديل الان", "error");
    }
  }, [loading, res]);
  useEffect(() => {
    if (resCurrnt && resCurrnt.PhoneNumber) {
      localStorage.setItem("userajindamuhami", JSON.stringify(resCurrnt));
    }
  }, [resCurrnt]);
  return (
    <div className="enterr">
      <Container>
        <h4 className="text-center">البيانات الشخصية</h4>
        <div className="inputs-container">
          {/* <div className="inp-container ">
            {" "}
            <TextField
              className="cod"
              focused
              label="كود المستخدم"
              variant="outlined"
              value={Code}
              onChange={tryChangeCode}
            />
          </div> */}

          <div className="inp-container ">
            <TextField
              focused
              inputProps={{ maxLength: 120 }}
              type="text"
              label="اسم المستخدم"
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              value={Name}
            />
          </div>
          <div className="inp-container ">
            <TextField
              focused
              label="رقم الهاتف"
              inputProps={{ maxLength: 15 }}
              type="number"
              variant="outlined"
              value={Phone}
              onChange={tryChangePhone}
            />
          </div>
          <div className="inp-container ">
            <TextField
              focused
              label={
                <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                  البريد الألكتروني
                  <span style={{ color: "red", fontSize: "11px" }}>
                    (أختياري)
                  </span>
                </Typography>
              }
              variant="outlined"
              value={Email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              className="em"
            />
          </div>
          <div className="inp-container ">
            <TextField
              label="كلمة المرور"
              variant="outlined"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              type={Passwordp}
            />

            <button className="btn btn-primary e" onClick={togglep}>
              {Passwordp === "password" ? (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-slash-fill"
                  viewBox="0 0 16 16">
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-fill"
                  viewBox="0 0 16 16">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                </svg>
              )}
            </button>
          </div>
          <div className="inp-container ">
            {" "}
            <TextField
              label="تأكيد كلمة المرور"
              variant="outlined"
              onChange={(e) => setpasswordconfirmInput(e.target.value)}
              type={Passwordc}
              value={passwordconfirmInput}
            />
            <button className="btn btn-primary c" onClick={togglec}>
              {Passwordc === "password" ? (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-slash-fill"
                  viewBox="0 0 16 16">
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                </svg>
              ) : (
                <svg
                  width="20"
                  height="17"
                  fill="currentColor"
                  className="bi bi-eye-fill"
                  viewBox="0 0 16 16">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                </svg>
              )}
            </button>
          </div>
        </div>
        {isPress && loading ? (
          <button className="buttonadd" type="button">
            <Spinner animation="border" role="status"></Spinner>
          </button>
        ) : (
          <button onClick={handlesubmit} className="buttonadd" type="button">
            حفظ التعديلات
          </button>
        )}
      </Container>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Profile;
